import React from 'react';
import { createElementKey } from 'utils';
import { Section } from '../section';
import { SectionSubTitle } from '../section-subtitle';
import { stageImage, stageList, stageName, stageText } from './stages-section-styles';
import { Typography } from '../typography';
import { Stage } from './stages-section-types';

type StagesSectionProps = {
  sectionTitle: string;
  stages: Stage[];
};

export const StagesSection: React.FC<StagesSectionProps> = ({ sectionTitle, stages }) => (
  <Section>
    <SectionSubTitle margin="m">{sectionTitle}</SectionSubTitle>
    <ol className={stageList}>
      {stages.map((stage, index) => (
        <li key={createElementKey('stage', index)}>
          <img
            className={stageImage}
            src={stage.imageSrc}
            alt={stage.imageAlt}
            title={stage.imageAlt}
            width="372"
            height="262"
            loading="lazy"
          />
          <Typography className={stageName} variant="h3">
            {index + 1}. {stage.name}
          </Typography>
          <Typography className={stageText} variant="m" size="body_short">
            {stage.text}
          </Typography>
        </li>
      ))}
    </ol>
  </Section>
);
